import { IconButton } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Edit } from '@material-ui/icons';
import Alert from '@material-ui/lab/Alert';
import * as React from 'react';
import Truncate from 'v2/components/Shared/TruncateText';
import { formatMoney } from 'v2/helpers/money';

import type IProduct from 'interfaces/IProduct';

type BasePlanTableProps = {
  product: IProduct;
  openPlanModal: () => void;
};

function BasePlanTable({ product, openPlanModal }: BasePlanTableProps) {
  function getFrequencyType(type = 'M') {
    const frequencyText = {
      M: 'Mensal',
      TM: 'Trimestral',
      SM: 'Semestral',
      Y: 'Anual',
      P: 'Personalizado',
    };

    return frequencyText[type];
  }

  const brlProductPrice = product.prices.find((price) => price.currency_code === 'BRL');

  return (
    <>
      <TableContainer>
        <Table size='small'>
          <TableHead>
            <TableCell>Plano</TableCell>
            <TableCell width={110}>Frequência</TableCell>
            <TableCell width={110}>Valor</TableCell>
            <TableCell width={180}>Forma de cobrança</TableCell>
            <TableCell width={75} align='center' />
          </TableHead>
          <TableBody>
            <TableRow key={1}>
              <TableCell style={{ whiteSpace: 'nowrap' }}>
                <Truncate count={20} style={{ display: 'inline-block' }}>
                  {product.plan_title}
                </Truncate>
              </TableCell>
              <TableCell>{getFrequencyType(product.recurring_frequency_type)}</TableCell>
              <TableCell>{formatMoney(brlProductPrice?.value || 0)}</TableCell>
              <TableCell>{product.undetermined_charges ? 'Infinita' : 'Finita'}</TableCell>
              <TableCell align='right'>
                <IconButton id={`offer-actions-${1}`} size='small' onClick={openPlanModal}>
                  <Edit fontSize='small' />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Alert severity='success' style={{ marginTop: 16 }}>
        Você tem um plano configurado e já pode continuar o cadastro do seu produto.
      </Alert>
    </>
  );
}

export { BasePlanTable };
